import { ExportFilesSearchRefetch } from '@/context/services/export_files/type';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const ExportFilesSearchContext = createContext<
  ExportFilesSearchRefetch | undefined
>(undefined);

type TValue<T extends Function> = {
  value: T;
};

export const ExportFilesSearchRefetchProvider: FC<
  PropsWithChildren<TValue<ExportFilesSearchRefetch>>
> = ({ children, value }) => {
  return (
    <ExportFilesSearchContext.Provider value={value}>
      {children}
    </ExportFilesSearchContext.Provider>
  );
};

export const useExportFilesSearchRefetch = ():
  | ExportFilesSearchRefetch
  | undefined => useContext(ExportFilesSearchContext);
